import type { AbTestConfig } from './types'

export const AB_TEST_CONFIGS: AbTestConfig[] = [
    // issueNumber '3060'（/instagram_asc、転職意欲モーダルのABCテスト）はDEV-3060の結果
    // （有意差なし）により終了・削除。オリジナル(A)100%に切り戻し。詳細はGit履歴を参照。
    // issueNumber '3182'（/tiktok_smart_plus、FV画像切り戻し＋転職意欲POP有無のABテスト）は
    // DEV-3230によりBパターン（POPなし）採用のため終了・削除。詳細はGit履歴を参照。
    // issueNumber '3061'（instagram_asc＋Google広告系全流入LP、EFステップ遷移の横型/縦型ABテスト）は
    // DEV-3300によりBパターン（縦型EF）採用のため終了・削除。詳細はGit履歴を参照。
    // issueNumber '3239'（hotelslabo googleAd全5エリア＋instagram_asc（tiktok_smart_plus連動）、FVショート
    // デザイン変更のABCテスト）はDEV-3318によりAパターン（現行デザイン）に切り戻しのため終了・削除。詳細はGit履歴を参照。
    // issueNumber '3254'（/tiktok_smart_plus、指マーク(FollowIcon)とCTA誘導ハイライト
    // (NextActionOverlay等)の有無のABテスト）はDEV-3301によりAパターン（両方あり）採用のため
    // 終了・削除。詳細はGit履歴を参照。
    // issueNumber '3317'（hotelslabo googleAd全5エリア＋instagram_asc、EFステップ遷移の横型/縦型
    // ABテスト）はDEV-3378によりAパターン（横型EF）採用のため終了・削除。instagram_ascのA:B比率を
    // 5:5→8:2に変更したDEV-3347も、対象configごと削除されるため併せて無効化。詳細はGit履歴を参照。
    // issueNumber '3328'（instagram_asc＋Google広告系全流入LP、FV有無のABテスト）はDEV-3366により
    // 終了・削除。B（FV無し＋吹き出しガイダンス）が勝ったがブランディング上の情報を残したいという
    // 判断のため、Bをそのまま採用せずAパターン（現行FV）に戻したうえで後続の '3366' へ引き継ぐ。
    // 詳細はGit履歴を参照。
    // issueNumber '3366'（instagram_asc＋Google広告系全流入LP、FV訴求変更のABCテスト）は
    // DEV-3419によりCパターン（No.1帯＋企業ロゴ帯＋EFバナーのstep1カード内移動）採用のため
    // 終了・削除。Cは全対象ページに恒久反映済み。詳細はGit履歴を参照。
    // issueNumber '3330'（/tiktok_smart_plus、EFステップ遷移の横型/縦型ABテスト）は
    // DEV-3418によりBパターン（縦型EF）採用のため終了・削除。縦型EFはgoogleAd系・
    // instagram_asc（DEV-3061→DEV-3300）に続きtiktokでも恒久反映。なお縦型EFは上記 '3254'
    // でA（指マーク＋CTA誘導ハイライト両方あり）を採用した構成とは別物で、オーバーレイ系の
    // 誘導を持たない（指マークはアクティブカードのみ）。'3254' の結論と矛盾しているのではなく、
    // DEV-3418時点の/tiktok_smart_plusの実装は縦型EF側が正。詳細はGit履歴を参照。
    // issueNumber '3392'（foodslabo AGLPサンクス /foodslabo/thanks、PF転換フォームバナー
    // （スカウト訴求）のデザインABCDテスト）はDEV-3586によりCパターン（「次のステップへ」訴求＋
    // KUZEN(LINE連携)バナーを10秒後・ブラウザバック時のモーダルへ移設）採用のため終了・削除。
    // Cは全流入に恒久反映済み。ただしこのブロックは会員登録済みかつPF未転換の人にだけ出るもので、
    // 未登録・既にPF転換済みの訪問者は従来のレイアウト（KUZEN未連携ならページ内のKUZENバナー、
    // 連携済みならTEL画像）のまま。
    // 未解決だったTODO（チケット本文の対象はinstagram_asc流入限定だが、サンクスのURLは流入元に
    // 関係なく共通）は100%反映で論点ごと消滅。AGで振ったパターンをPFの計測へ引き継ぐ仕組み
    // （ab_token）もAG側は撤去済みで、PF側の撤去はDEV-3602。詳細はGit履歴を参照。
    {
        issueNumber: '3379',
        patterns: [
            { pattern: 'A', percentage: 50 },
            { pattern: 'B', percentage: 50 },
        ],
        // 対象: hotelslabo googleAd全5エリア（/hotels/google_adwords(_kansai|_sapporo|_nagoya|_fukuoka)/）
        // + instagram_asc（/hotels/instagram_asc/）。tiktok_smart_plusはinstagram_ascと同一
        // コンポーネントを使うが今回も対象外（DEV-3317と同じ扱い。regexもDEV-3317と同一）。
        // チケット本文は/hotels/google_adwords/のみの記載だが、他4エリアも同一コンポーネントのため
        // DEV-3239・DEV-3317の前例に合わせて全5エリアを対象とした。
        // 初手ポップ(JobChangeInterestModal)の有無のA/Bテスト。A=現行どおり表示 / B=非表示。
        pathRegex: /^\/hotels\/(?:google_adwords(?:_(?:kansai|sapporo|nagoya|fukuoka))?|instagram_asc)\/?$/,
        isActive: true,
    },
    {
        issueNumber: '3390',
        // Aパターンは存在しない。対象流入は全数がテスト対象で、Bが対照群（＝現行FV）。
        // 対照群をAにするとサフィックスが付かず（core.tsのgetGtmPrefix）、テスト対象外の
        // 流入の計測値と混ざって分離できなくなるため、対照群もBとして名札を付けている。
        // abValue 0〜4→B / 5〜9→C（Dは配分0で到達しない。DEV-3560）
        patterns: [
            { pattern: 'B', percentage: 50 },
            { pattern: 'C', percentage: 50 },
            { pattern: 'D', percentage: 0 },
        ],
        // 対象: foodslabo の /instagram_asc/ のみ。/instagram_organic/ は同じビュー
        // （app/views/instagram/renewal/index.html.erb）と同じコンポーネントを描くが、
        // ここで除外する。hotelslaboの /hotels/instagram_asc/ は先頭アンカーで不一致（'3379'側）。
        // カフェ訴求クリエイティブのFV出し分け。
        //   B: 現行FV（求人数No.1の73px帯）のまま
        //   C: カフェ訴求のFV（375x231）に差し替え
        //   D: 現行帯にカフェのカテゴリ表記を足したショート版（375x99）に差し替え
        //      → DEV-3560でCVR効率が悪く配分0（出さない）。描画分岐もCafeFirstViewのshort
        //        variantも画像も残してあるので、戻すならpercentageを振り直すだけでよい。
        // 企業ロゴ帯・調査注記・縦型EFは3パターンとも共通（Figma確認済み）。
        pathRegex: /^\/instagram_asc\/?$/,
        // カフェ訴求の判別は広告のメディアコード mc（数字列）の11〜14文字目が '0010' であること
        // （例 ?mc=16700000000010028300000）。先頭10文字を \d で縛っているのは、
        // 空白や記号が頭に付いた値で桁がずれたまま一致してしまうのを防ぐため。
        targetQuery: { param: 'mc', pattern: /^\d{10}0010/ },
        // 本configは cookie ab_value_3390 の「存在」を参加印に兼用している（sticky）。
        // mcが落ちた再訪でも同じパターンを出し続けるための仕様。cookieのmax-ageは1年なので、
        // 比率や中身を変えて仕切り直す場合は必ず新しいissueNumberで作ること
        // （同じ番号で再開すると、旧参加者が旧バケットのままmc無しで自動参加する）。
        // DEV-3560の配分変更は、上記に反するが意図的に同じ'3390'のまま行っている。新番号にすると
        // cookieが新規発行になり、mcが落ちた再訪の既存参加者がテストから抜けて素ラベル側に落ちる
        // ため。代わりに既存参加者の一部がパターンを移る（4がC→B、7〜9がD→C）ので、集計は
        // DEV-3560のリリース日時で必ず区切ること。同番号での比率変更はDEV-3347にも前例あり。
        isActive: true,
    },
    {
        issueNumber: '3484',
        patterns: [
            { pattern: 'A', percentage: 50 },
            { pattern: 'B', percentage: 50 },
        ],
        // 対象: foodslabo の geniee系4URL（/geniee_line/ /geniee_line/sp/ /geniee/ /geniee/sp/）。
        // 4つとも job_seeker#geniee_line / #geniee から同じ geniee/index を描画する同一コンポーネント。
        // チケット本文は /geniee_line/ のみの記載だが、かご落ち配信の /geniee/ 系もFVが古いままのため
        // PO確認のうえ全4URLを対象とした。/geniee_line_ad/ は別テンプレート(geniee/ad/ad)なので一致させない。
        // A=現行のヒーローFV＋好条件帯＋初手ポップ
        // B=No.1帯＋企業ロゴ帯＋調査注記、初手ポップ(JobChangeInterestModal)なし。
        //   ポップ非表示はhotelslaboのDEV-3379のB相当で、foodslaboのinstagram・googleAdは今も出している。
        //   FVとポップの2要因を同時に変えるため、勝敗が出ても要因の分離はできない。
        // EFのレイアウト（上部バナー廃止＋ステッパー先頭＋バナーをstep1カード内へ）はA/B共通で
        //   100%反映している。PO確認のうえ、テスト対象外の差分として先に揃えた。
        // 集計の注意: Aはサフィックスが付かず(core.tsのgetGtmPrefix)、素のラベルは他チャネルのLPと
        //   同じ文字列なので、A群は必ず page_path を上記4URLに絞って数えること（DEV-3379と同じ運用）。
        // 同じく集計の注意: FVと初手ポップ以外のラベル（HD・EF_StepForm_Step1）は、判定確定前に
        //   素のラベルでDOMに載り、確定後に属性だけが書き換わる（useAbTestGtmが未確定時は素のラベルを
        //   返すため）。稼働中のDEV-3379も同じ作りで、基盤側の性質。実測ではマウントと書き換えが
        //   同一のMutationObserverバッチ・同一rAFフレームで起き、間にペイントが入らないため
        //   GTMが素のラベルで拾う隙は無いが、低速端末では中間ペイントが入りうる。
        //   B群のHD・Step1の表示数は参考値として扱い、比較は判定確定後に発生するラベル
        //   （クリック・CV）で行うこと。
        pathRegex: /^\/geniee(?:_line)?(?:\/sp)?\/?$/,
        isActive: true,
    },
]
